/**
 * Why "Run auto-design" cannot run yet, in words the user can act on.
 *
 * The button used to sit greyed out with no reason given: most often because
 * the project had never been saved (the design report is stored against the
 * project, so the endpoint needs its id). Each reason names what to do and
 * where, so the user is never left guessing.
 */

const FIELD_NAMES = {
  Latitude: ["Γεωγραφικό πλάτος", "Latitude"],
  Longitude: ["Γεωγραφικό μήκος", "Longitude"],
  "Roof area": ["Επιφάνεια εδάφους (Τοποθεσία & Γενικά)", "Terrain area (Location & General)"],
  Tilt: ["Κλίση (Σύστημα & Προσανατολισμός)", "Tilt (System & Orientation)"],
  Azimuth: ["Αζιμούθιο (Σύστημα & Προσανατολισμός)", "Azimuth (System & Orientation)"],
  "Roof pitch": ["Κλίση στέγης (Σύστημα & Προσανατολισμός)", "Roof pitch (System & Orientation)"],
  "Roof facing": ["Προσανατολισμός στέγης (Σύστημα & Προσανατολισμός)", "Roof facing (System & Orientation)"],
  "Target DC size": ["Στόχος ισχύος DC (kWp)", "Target DC size (kWp)"],
};

/** The name of a missing input as the screen shows it. Unknown keys pass through. */
export function autoDesignInputName(key, isGreek) {
  const pair = FIELD_NAMES[key];
  if (!pair) return key;
  return isGreek ? pair[0] : pair[1];
}

/**
 * @param {object} o
 * @param {boolean} o.projectSaved   the project has an id on the server
 * @param {string[]} o.missing       keys from requiredAutoInputs()
 * @param {boolean} o.sharesInvalid  several orientations whose shares do not total 100 %
 * @param {boolean} o.isGreek
 * @returns {string[]} one sentence per reason; empty when the run can start
 */
export function autoDesignBlockers({ projectSaved, missing = [], sharesInvalid = false, isGreek = false }) {
  const out = [];
  if (!projectSaved) {
    out.push(isGreek
      ? "Αποθηκεύστε πρώτα το έργο (Αρχείο → Αποθήκευση ως…). Η αυτόματη σχεδίαση αποθηκεύει την αναφορά της στο έργο, γι' αυτό χρειάζεται αποθηκευμένο έργο."
      : "Save the project first (File → Save as…). The auto-design stores its report with the project, so it needs a saved project.");
  }
  if (missing.length) {
    const names = missing.map((m) => autoDesignInputName(m, isGreek)).join(", ");
    out.push(isGreek ? `Συμπληρώστε: ${names}.` : `Fill in: ${names}.`);
  }
  if (sharesInvalid) {
    out.push(isGreek
      ? "Τα ποσοστά ισχύος των προσανατολισμών πρέπει να αθροίζουν 100% (Σύστημα & Προσανατολισμός)."
      : "The power shares of the orientations must total 100% (System & Orientation).");
  }
  return out;
}
